import Vue from 'vue'
import VtSidePanel from '@/components/common/VtSidePanel.vue'
Vue.component('VtSidePanel', VtSidePanel)
